var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scorePicture",staticStyle:{"width":"600px","height":"300px"}},[_c('div',{ref:"main",staticStyle:{"width":"600px","height":"300px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }